import { secondaryTabsByRole } from './roleTabs';

export function BottomNav({ role, activeTab, onTabChange, labels, tabs }) {
  const tabList = tabs || [];
  const secondary = secondaryTabsByRole[role] || [];
  const navHighlight = secondary.includes(activeTab)
    ? activeTab === 'switchClass'
      ? 'switchClass'
      : 'more'
    : activeTab;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card/95 pb-safe shadow-[0_-4px_24px_rgba(0,0,0,0.06)] backdrop-blur-md dark:shadow-[0_-4px_24px_rgba(0,0,0,0.35)] lg:hidden"
      aria-label="Main navigation"
    >
      <div className="flex justify-around">
        {tabList.map(({ id, labelKey, icon: Icon }) => {
          const active = navHighlight === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onTabChange(id)}
              className={`flex min-h-[3.25rem] flex-1 flex-col items-center justify-center gap-0.5 px-0.5 py-1.5 text-center font-medium transition-colors ${
                active ? 'text-primary' : 'text-muted hover:text-text'
              }`}
            >
              <Icon className="h-5 w-5 shrink-0" strokeWidth={active ? 2.5 : 2} />
              <span className="label-wrap line-clamp-2 w-full text-[10px] leading-tight sm:text-[11px]">
                {labels[labelKey] || id}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
